import React from 'react';
import { Row, Col, Button } from 'antd'
import { COLOR, FONT } from '../constants';
import MintButton from './MintButton'
import useResponsive from '../hooks/useResponsive'
import TNContent from './TNContent';


const CollectionFAQ = (props) => {

  const { isMobile } = useResponsive();

  return (
    <TNContent maxWidth={1920}>
      <Row
        justify='center'
        style={isMobile ? {
          backgroundColor: COLOR.background,
          paddingTop: '6%',
          textAlign: 'center',
        } : {
          backgroundColor: COLOR.background,
          paddingTop: '6%',
          textAlign: 'center',
          paddingBottom: 120
        }}>
        <Col span={20}>
          <Row justify='center' style={{ marginBottom: 20 }}>
            <Col span={12}>
              <img src="./assets/primary_star.svg" alt="" style={{ width: 40 }} />
            </Col>
            <Col span={24}><span style={{ ...FONT.h5, color: COLOR.primary }}>FAQ</span></Col>
          </Row>
          <Row justify='space-between' style={{ marginBottom: 20 }}>
            <Col xs={0} sm={0} md={0} lg={6}>
              <span
                style={{
                  border: '4px solid #000000',
                  boxShadow: '6px 7px 0px #000000',
                  ...FONT.h5,
                  padding: 20,
                  borderRadius: 8
                }}
              >
                {'>> __DESKTOP__'}
              </span>
            </Col>
            <Col xs={24} sm={24} md={24} lg={10} style={{ marginBottom: 10 }}><span style={{ ...FONT.h3, color: COLOR.heading, textAlign: 'center' }}>What’s next ?</span></Col>
            <Col xs={0} sm={0} md={0} lg={6}>
              <span
                style={{
                  border: '4px solid #000000',
                  boxShadow: '6px 7px 0px #000000',
                  ...FONT.h5,
                  padding: 20,
                  borderRadius: 8
                }}
              >
                {'>> __MOBILE__'}
              </span>
            </Col>
          </Row>
          <Row justify='center' style={isMobile ? { marginBottom: -20 } : { marginBottom: -20, height: '85%' }}>
            <Col xs={24} sm={24} md={24} lg={20}>
              <Row justify='space-evenly' align='top' gutter={[0, 24]}>
                <Col
                  xs={24}
                  sm={24}
                  md={11}
                  style={isMobile ? {
                    border: '4px solid #000000',
                    boxShadow: '6px 7px 0px #000000',
                    ...FONT.h5,
                    paddingTop: 20,
                    paddingRight: 20,
                    paddingLeft: 20,
                    paddingBottom: 20,
                    borderRadius: 8,
                    backgroundColor: COLOR.whiteBackground,
                    height: '40%'
                  } : {
                    border: '4px solid #000000',
                    boxShadow: '6px 7px 0px #000000',
                    ...FONT.h5,
                    paddingTop: 20,
                    paddingRight: 20,
                    paddingLeft: 20,
                    paddingBottom: 59,
                    borderRadius: 8,
                    backgroundColor: COLOR.whiteBackground,
                    height: '100%'
                  }}
                >
                  <p style={{ ...FONT.h6, color: COLOR.text, textAlign: 'start' }}>If you are using desktop</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(1) Open Chrome/ Firefox/ Brave browser</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(2) Download Phantom/ Solana wallet extension</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(3) Create account & save recovery phrase</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(4) Click "Get Whitelist Token"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(5) Click "Connect wallet"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(6) Fill in the whitelist form & submit</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(7) Receive Shiba9 whitelist token in wallet upon approval</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(8) Ensure you have > 0.014 SOL in wallet</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(9) Click "Start Minting" & "Mint Your Shiba9"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(10) Click "Approve" to proceed transaction*</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(11) Finish</p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={11}
                  style={isMobile ? {
                    border: '4px solid #000000',
                    boxShadow: '6px 7px 0px #000000',
                    ...FONT.h5,
                    paddingTop: 20,
                    paddingRight: 20,
                    paddingLeft: 20,
                    paddingBottom: 20,
                    borderRadius: 8,
                    backgroundColor: COLOR.whiteBackground,
                    height: '40%'
                  } : {
                    border: '4px solid #000000',
                    boxShadow: '6px 7px 0px #000000',
                    ...FONT.h5,
                    paddingTop: 20,
                    paddingRight: 20,
                    paddingLeft: 20,
                    paddingBottom: 20,
                    borderRadius: 8,
                    backgroundColor: COLOR.whiteBackground,
                    height: '100%'
                  }}
                >
                  <p style={{ ...FONT.h6, color: COLOR.text, textAlign: 'start' }}>If you use your mobile phone</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(1) Copy URL -
                    <span style={{ ...FONT.text, color: COLOR.textSecondary, textAlign: 'start' }}> shiba9.technine.io</span></p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(2) Download or open Phantom/ Solana wallet app</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(3) Create account & save recovery phrase</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(4) Go to browser tab & paste URL</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(5) Click "Get Whitelist Token"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(6) Click "Connect Wallet"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(7) Fill in the whitelist form & submit</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(8) Receive Shiba9 whitelist token in wallet upon approval</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(9) Ensure you have > 0.014 SOL in wallet</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(10) Click "Start Minting" & "Mint Your Shiba9"</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(11) Click "Approve" to proceed transaction*</p>
                  <p style={{ ...FONT.text, color: COLOR.text, textAlign: 'start' }}>(12) Finish</p>
                </Col>
              </Row>
            </Col>
          </Row>

          {isMobile ?
            <Row style={{ paddingTop: 50 }}>
              <Col span={24}><span style={{ ...FONT.smallContent, textAlign: 'center', color: COLOR.captionText }}>
                * Please expect waiting time around few seconds to minutes for transactions on Solana blockchain.
              </span></Col>
            </Row>
            :
            <Row style={{ marginBottom: 10 }}>
              <Col span={24}><span style={{ ...FONT.smallContent, textAlign: 'center', color: COLOR.captionText }}>
                * Please expect waiting time around few seconds to minutes for transactions on Solana blockchain. </span></Col>
            </Row>
          }
        </Col>
      </Row>
    </TNContent>
  )
}

export default CollectionFAQ;